An array of identifiers for the position's `Location`s.
